// Constants - URLs, images, and config shared across the app

export const LOGO_URL = "https://customer-assets.emergentagent.com/job_ff5e520a-600e-4b33-acab-53b3a459ee62/artifacts/qj8tlz82_BODY%20UP_logo%20neg.png";
export const STUDIO_IMAGE = "https://customer-assets-agu9un31.emergentagent.net/job_7ec0a196-30d6-48cc-b4da-a55574a12eb3/artifacts/il4apru0_694ACA59-C9EF-4D62-A03A-393EF85A5BB7.png";
export const LAURENT_IMAGE = "https://customer-assets.emergentagent.com/job_ff5e520a-600e-4b33-acab-53b3a459ee62/artifacts/bybma9wa_ab2d1abb-e924-4988-b6e8-26c4d2904455.jpeg";
export const TARAH_IMAGE = "https://customer-assets.emergentagent.com/job_emstraining-nyon/artifacts/auzuz3jk_Image%2026.11.25%20a%CC%80%2002.33.jpeg";
export const BOOKING_URL = "https://book.pure-informatique.com/Categories.php?locationID=39210&sid=jfs5tf2haocgf7iukucvpp9rva#startConnexion";

/**
 * Liens Calendly (configurables via .env).
 * - DISCOVERY = appel découverte gratuit 15min (avant paiement)
 * - COACHING = 1er RDV coaching (après paiement, intégré Zoom)
 */
export const CALENDLY_DISCOVERY_URL = process.env.REACT_APP_CALENDLY_DISCOVERY_URL
  || 'https://calendly.com/info-body-up/decouverte-gratuite';
export const CALENDLY_COACHING_URL = process.env.REACT_APP_CALENDLY_COACHING_URL
  || 'https://calendly.com/info-body-up/coaching-online';
export const EMS_SITE_URL = "https://www.body-up-ems.ch";
export const WHATSAPP_NUMBER = "+41786044423";
export const WHATSAPP_URL = `https://wa.me/${"+41786044423".replace(/\+/g, '')}`;

export const SOCIAL_LINKS = {
  instagram: "https://www.instagram.com/body_up_personal_training/",
  facebook: "https://www.facebook.com/body.up.personal.training/",
  linkedin: "https://ch.linkedin.com/in/laurent-waelti-645333370"
};

export const GOOGLE_MAPS_URL = "https://www.google.com/maps/place/Body-Up+Personal+Training/@46.3833,6.2275,17z/";
export const GOOGLE_REVIEWS_URL = "https://www.google.com/maps/search/?q=Body+Up+Personal+Training+Nyon+avis";

export const SITE_URL = "https://body-up.ch";
export const OG_IMAGE = "https://customer-assets.emergentagent.com/job_ff5e520a-600e-4b33-acab-53b3a459ee62/artifacts/msvkd6v6_c3768191-0ed0-460a-a9d8-de45086a8c2a.jpeg";

export const IMAGES = {
  ems: "https://customer-assets.emergentagent.com/job_c307835a-9523-4b65-a9e3-3675ef49fef2/artifacts/l0pcmblb_trockentechnologie-als-gamechanger-im-ems-training-02.jpg.webp",
  boxing: "https://customer-assets.emergentagent.com/job_ff5e520a-600e-4b33-acab-53b3a459ee62/artifacts/ocuz9o2m_Introducing-boxing-nyon-personal-training.webp",
  scan3d: "https://customer-assets.emergentagent.com/job_ff5e520a-600e-4b33-acab-53b3a459ee62/artifacts/rac9a7nr_Scan-3d-Styku-analyse-Nyon.webp",
  hypoxie: "https://customer-assets.emergentagent.com/job_ff5e520a-600e-4b33-acab-53b3a459ee62/artifacts/q2jdewke_Hypoxie-altitude-coaching-sportif-nyon.webp",
  fitsonic: "https://customer-assets.emergentagent.com/job_ff5e520a-600e-4b33-acab-53b3a459ee62/artifacts/ts884du6_Ceinture-perte-de-gras-coaching-sportif-Nyon.webp"
};

export const SEO_LOCATIONS = {
  main: "Nyon",
  region: "La Côte",
  canton: "Vaud",
  country: "Suisse",
  nearby: ["Gland", "Rolle", "Coppet", "Prangins", "Founex", "Céligny", "Tannay", "Mies", "Versoix", "Genève", "Morges", "Aubonne", "Begnins", "Duillier", "Signy"],
  radius: "20km"
};

export const SEO_SERVICES = [
  "Personal Training", "Coaching Sportif", "EMS Training", "Électrostimulation",
  "Duo Training", "Perte de Poids", "Musculation", "Renforcement Musculaire",
  "Remise en Forme", "Préparation Physique", "Scan 3D Styku", "Plan Alimentaire"
];
